import { styled } from "@mui/material";

export const PositionWrapper = styled("div")(() => ({
  padding: "16px 0",
}));

export const Text = styled("span")(() => ({
  color: "#1D2939",
  fontFamily: "Manrope",
  fontSize: "0.875rem",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  marginTop: "8px",
}));

export const Wrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  paddingBottom: 16,
}));

export const Title = styled("span")(() => ({
  fontSize: "16px",
  fontWeight: 700,
  color: "#465869",
  lineHeight: "24px",
  fontFamily: "Manrope",
}));
